import React from "react";
import style from "css/template.module.css";
import { Link } from "react-router-dom";

/**
 * Version : 1.0
 * 작성일자 : 2025-02-10
 * 작성자 : 강연승
 * 설명 : 리브 홈페이지 footer 사이트맵 분야별 항목
 */

function SitemapItem(props) {
  const main = props.page.main;
  const sub = props.page.sub;
  return (
    <div className={style.sitemap_item}>
      {main?.location ? (
        <Link
          className={style.sitemap_title_link}
          to={`${process.env.REACT_APP_CLIENT_URL}` + main.location}
        >
          {main.label}
        </Link>
      ) : (
        <a className={style.sitemap_title_link}>{main.label}</a>
      )}

      {sub && sub.length > 0
        ? sub.map((item, index) =>
            item?.location ? (
              <Link
                key={index}
                className={style.sitemap_sub_link}
                to={`${process.env.REACT_APP_CLIENT_URL}` + item.location}
              >
                {item.label}
              </Link>
            ) : (
              <a
                key={index}
                className={style.sitemap_sub_link}
              >
                {item.label}
              </a>
            )
          )
        : null}
    </div>
  );
}

export default SitemapItem;
